import React from 'react';
import LinkCell from '@/components/table/LinkCell';
import SimpleCell from '@/components/table/SimpleCell';
import memberEntities from '../constants';

const MemberDescriptionCell = ({ member }) => (
  <>
    {member.entity === memberEntities.USERGROUP && (
    <SimpleCell className="td-members-description" content={member.description} />
    )}
    {member.entity !== memberEntities.USERGROUP && (<LinkCell title={member.name} value={member.email} />)}
  </>
);

export default MemberDescriptionCell;
